import { ErrorBase } from './error.base';

export class ErrorNoNetwork extends ErrorBase {

    constructor() {
        super('Network', 'Es besteht keine Netzwerkverbindung.')
    }

}
